import type { DataGridCellFormatterData } from "../widget";

export enum Status {
  Success = "success",
  Error = "error",
}

export enum PromiseAllSettledStatus {
  Fullfilled = "fulfilled",
  Rejected = "rejected",
}

export interface BaseResponse {
  errors?: ServiceError[];
  status: Status;
}

export interface BaseResponseWithSingle<T> {
  errors?: ServiceError[];
  status: Status;
  data?: T;
}

export interface BaseResponseWithMultiple<T> {
  errors?: ServiceError[];
  status: Status;
  data?: Array<T>;
}

export interface ServiceError {
  code: string;
  property?: string;
  path?: string;
  parameters?: { [key: string]: string };
  message: string;
}

export interface ResultData {
  [key: string]: string | number | boolean | Date | DataGridCellFormatterData | null | undefined;
}

export interface FilterCriteria<T extends string | number | Date | boolean | string[] | null> {
  operator:
    | "eq"
    | "neq"
    | "gt"
    | "lt"
    | "gte"
    | "lte"
    | "empty"
    | "notEmpty"
    | "startsWith"
    | "endsWith"
    | "contains"
    | "ncontains"
    | "in"
    | "nin";
  value: T;
}

export type SortDirection = "asc" | "desc";

export const errorCodeFormatRegex = /^[A-Z]+(?:_{0,1}[A-Z]+)*$/;

export type FilterGroupOperator = "or" | "and";

export type FilterGroup<T> = {
  operator: FilterGroupOperator;
  filter?: T;
  filterGroups?: FilterGroup<T>[];
};

export type FilterGroups<T> = { filterGroups?: FilterGroup<T>[] };
